import "./DragNDropManager.css";
import React from "react";
import { DragNDropFunctions } from "./DragNDropFunctions";
import { DragNDrop } from "./DragNDrop";
import CustomButton from "@/commons/components/buttons/customButton/CustomButton";
import FloatingInput from "@/commons/components/fields/floatingInput/FloatingInput";
import CustomSelect from "@/commons/components/fields/customSelect/CustomSelect";

let manager;

export class DragNDropManager extends React.Component {
    mainElement;
    elementsMap = new Map();
    popupId = "";
    submitAction;
    jsonTypeList = ["TEXT", "NUMBER", "COORDINATES", "SELECTION", "COMBO", "OPTION", "SUBMIT", "MESSAGE"];

    constructor(props) {
        super(props);
        manager = this;
        manager.popupId = "";

        this.setMainElement(this.newDragNDrop());
        this.mainElement.label = props.mainLabel ?? "Undefined";
        this.mainElement.name = props.mainLine2 ?? "";
        this.submitAction = props.onSubmit ?? (() => alert("onSubmit non definito su DragNDropManager"));

        this.state = {
            submitName: props.submitName ?? "Invia",
            popupLabel: "",
            popupName: "",
            popupDefValue: "",
            popupType: "TEXT",
            popupVisible: false
        };
    }

    updateSubmitName = (name) => {
        this.setState({ submitName: name });
    };

    showPopup = ({ label = "", name = "", defValue = "", type = "TEXT", id = "" }) => {
        this.popupId = id;
        this.setState({
            popupLabel: label,
            popupName: name,
            popupDefValue: defValue,
            popupType: type.toUpperCase(),
            popupVisible: true
        });
    };

    hidePopup = () => {
        this.setState({ popupVisible: false });
    };

    saveData = () => {
        const { popupLabel, popupName, popupDefValue, popupType } = this.state;
        const id = manager.popupId;
        const scope = popupType === "OPTION" ? "PARAMETER" : "FORM";

        if (id === "") {
            this.newDragNDrop(scope, popupType, popupName, popupLabel, popupDefValue);
        } else {
            const element = this.getElementByUID(id);
            if (element) {
                element.define(scope, popupType, popupName, popupLabel, popupDefValue);
            }
        }

        this.hidePopup();
        this.forceUpdate();
    };

    deleteElement = () => {
        const id = manager.popupId;
        if (id !== "") {
            const elementObj = this.getElementByUID(id);
            if (elementObj && elementObj !== this.getMainElement()) {
                const parent = this.findParentElement(id);
                if (parent) {
                    parent.childrens = parent.childrens.filter(item => item.UID !== id);
                }
                this.elementsMap.delete(id);
            }
        }
        this.hidePopup();
        this.forceUpdate();
    };


    loadNewEditor = () => {
        this.showPopup({});
    };

    loadEditor = () => {
        const element = this.getElementByUID(manager.popupId);
        if (!element) return;
        this.showPopup({
            label: element.label,
            name: element.name,
            defValue: element.defValue,
            type: element.type,
            id: element.UID
        });
    };

    handleMouseDown(event) {
        if (event.button === 2) {
            event.preventDefault();
            manager.popupId = event.target.id;
            this.loadEditor();
        }
    }

    handleContestMenu(event) {
        event.preventDefault();
    }

    delay = (time) => new Promise(resolve => setTimeout(resolve, time));

    loadJson = (json) => {
        if (this.getMainElement()) {
            const mainElDOM = document.getElementById(this.getMainElement().UID);
            if (mainElDOM) mainElDOM.innerHTML = "";
        }
        if (!json) return;
        let parsed = json;
        if (typeof parsed !== "object") {
            try {
                parsed = JSON.parse(json);
            } catch {
                return;
            }
        }
        if (Array.isArray(parsed)) {
            parsed.forEach(item => {
                const e = this.createElement(item);
                this.mainElement.addChildren(e);
            });
        } else {
            const e = this.createElement(parsed);
            this.mainElement.addChildren(e);
        }
        manager.forceUpdate();
        this.delay(100).then(() => {
            this.loadChildrens(this.mainElement, null);
            manager.forceUpdate();
        });
    };

    loadChildrens(dragNDrop, parentElement) {
        if (!dragNDrop) return;
        parentElement = parentElement ?? document.getElementById(dragNDrop.UID);
        if (!parentElement) return;
        const childs = dragNDrop.childrens;
        if (childs) {
            childs.forEach(item => {
                const childEl = document.getElementById(item.UID);
                if (childEl) {
                    parentElement.appendChild(childEl);
                    this.loadChildrens(item, childEl);
                }
            });
        }
    }

    createElement(json) {
        if (!json) return;
        const element = new DragNDrop();
        element.define(
            json.formScope ?? "FORM",
            json.type ?? "TEXT",
            json.name ?? "name",
            json.label ?? "label",
            json.defaultValue ?? "1"
        );
        this.registerElement(element);
        if (json.childrens) {
            json.childrens.forEach(item => {
                const child = this.createElement(item);
                element.addChildren(child);
            });
        }
        return element;
    }

    newDragNDrop(scope = "FORM", type = "TEXT", name = "name", label = "label", defValue = "defValue") {
        const dragNDrop = new DragNDrop();
        dragNDrop.define(scope, type, name, label, defValue);
        this.registerElement(dragNDrop);

        if (!this.getMainElement()) {
            this.setMainElement(dragNDrop);
        } else {
            this.getMainElement().addChildren(dragNDrop);
        }
        return dragNDrop;
    }

    registerElement(element) {
        this.elementsMap.set(element.UID, element);
    }

    getElementsMap() {
        return this.elementsMap;
    }

    getElementByUID(UID) {
        return this.elementsMap.get(UID);
    }

    setMainElement(mainElement) {
        this.mainElement = mainElement;
    }

    getMainElement() {
        return this.mainElement;
    }

    findParentElement(childUID) {
        for (const element of this.elementsMap.values()) {
            if (element.childrens.some(ch => ch.UID === childUID)) {
                return element;
            }
        }
        return null;
    }

    popupRender = () => {
        const { popupLabel, popupName, popupDefValue, popupType, popupVisible } = this.state;
        return (
            <div className={`popup-main ${popupVisible ? "popup-open" : ""}`} id="popup-main">
                <div className="popup-overlay" onClick={this.hidePopup}></div>
                <div className="popup-content">
                    <CustomSelect
                        label="Type"
                        options={this.jsonTypeList.map(typeOption => ({
                            label: typeOption,
                            value: typeOption,
                        }))}
                        value={popupType}
                        onChange={(val) => this.setState({ popupType: val })}
                        id="popup-type"
                    />
                    <br />
                    {popupType === "MESSAGE" ? (
                        <FloatingInput
                            label="Contenuto"
                            type="textarea"
                            id="popup-label"
                            value={popupLabel}
                            onChange={(e) => this.setState({ popupLabel: e.target.value })}
                        />
                    ) : (
                        <FloatingInput
                            label="Label (Visibile)"
                            type="text"
                            id="popup-label"
                            value={popupLabel}
                            onChange={(e) => this.setState({ popupLabel: e.target.value })}
                        />
                    )}
                    <br />
                    <FloatingInput
                        label="Name"
                        type="text"
                        id="popup-name"
                        value={popupName}
                        onChange={(e) => this.setState({ popupName: e.target.value })}
                    />
                    <br />
                    <FloatingInput
                        label="Default Value"
                        type="text"
                        id="popup-defValue"
                        value={popupDefValue}
                        onChange={(e) => this.setState({ popupDefValue: e.target.value })}
                    />
                    <br />
                    <CustomButton className="dragNDropButton" onClick={this.saveData}>
                        {this.popupId === "" ? "Crea" : "Salva"}
                    </CustomButton>
                    {this.popupId !== "" && (
                        <CustomButton className="dragNDropButton" onClick={this.deleteElement}>
                            Elimina
                        </CustomButton>
                    )}
                    <CustomButton className="dragNDropButton" onClick={this.hidePopup}>
                        Indietro
                    </CustomButton>
                </div>
            </div>
        );
    };

    render() {
        const { submitName } = this.state;
        const mapElements = Array.from(this.getElementsMap().values()).filter(
            item => item !== this.getMainElement()
        );

        return (
            <>
                {this.popupRender()}
                <div className="categoryCreateTitle" id="categoryCreateTitle">
                    {this.mainElement.label}<br />
                    {this.mainElement.name}
                </div>
                <div className="superBoxTree">
                    <div className="mainChildren" id={this.mainElement.UID}>
                        {mapElements.map(item => (
                            <div
                                className="subChildren"
                                id={item.UID}
                                key={item.UID}
                                draggable
                                onDragStart={DragNDropFunctions.handleDragStart}
                                onDragOver={DragNDropFunctions.handleDragOver}
                                onDrop={DragNDropFunctions.handleDrop}
                                onMouseDown={(e) => this.handleMouseDown(e)}
                                onContextMenu={(e) => this.handleContestMenu(e)}
                            >
                                {item.render()}
                            </div>
                        ))}
                    </div>
                </div>
                <CustomButton className="createFormElement" onClick={this.loadNewEditor}>
                    <div className="addFormElement">+</div>
                </CustomButton>
                <CustomButton className="createFormElement" onClick={() => this.returnData()}>
                    <div className="addFormElement">{submitName}</div>
                </CustomButton>
            </>
        );
    }

    returnData() {
        const json = this.getJSONData();
        this.submitAction(json);
    }

    getJSONData() {
        this.build();
        return this.getMainElement().getJSON().childrens;
    }

    build() {
        this.buildChildren();
    }

    buildChildren() {
        const UID = this.getMainElement().UID;
        const elementDOM = document.getElementById(UID);
        if (!elementDOM) return;
        this.buildChildrenSpecific(elementDOM);
    }

    buildChildrenSpecific(element) {
        const UID = element.id;
        const elementDragNDrop = this.getElementByUID(UID);
        if (!elementDragNDrop) return;
        elementDragNDrop.childrens = [];
        const children = element.children;
        for (let i = 0; i < children.length; i++) {
            const child = children[i];
            if (child.id && child.tagName.toUpperCase() === "DIV") {
                const childDragNDrop = this.getElementByUID(child.id);
                if (childDragNDrop) {
                    elementDragNDrop.addChildren(childDragNDrop);
                    this.buildChildrenSpecific(child);
                }
            }
        }
    }
}
